import {
  ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_ERROR,
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_ERROR,
  REMOVE_ADDRESS,
  REMOVE_ADDRESS_SUCCESS,
  REMOVE_ADDRESS_ERROR,
  MODIFY_ADDRESS,
  MODIFY_ADDRESS_SUCCESS,
  MODIFY_ADDRESS_ERROR,
} from '../actionTypes';

export const addAddress = (data) => ({
  type: ADD_ADDRESS,
  payload: data,
});

export const addAddressSuccess = (user) => ({
  type: ADD_ADDRESS_SUCCESS,
  payload: user,
});

export const addAddressError = (message) => ({
  type: ADD_ADDRESS_ERROR,
  payload: message,
});

export const fetchAddresses = (data) => ({
  type: FETCH_ADDRESSES,
  payload: data,
});

export const fetchAddressesSuccess = (user) => ({
  type: FETCH_ADDRESSES_SUCCESS,
  payload: user,
});

export const fetchAddressesError = (message) => ({
  type: FETCH_ADDRESSES_ERROR,
  payload: message,
});

export const removeAddress = (data) => ({
  type: REMOVE_ADDRESS,
  payload: data,
});

export const removeAddressSuccess = (user) => ({
  type: REMOVE_ADDRESS_SUCCESS,
  payload: user,
});

export const removeAddressError = (message) => ({
  type: REMOVE_ADDRESS_ERROR,
  payload: message,
});

export const modifyAddress = (data) => ({
  type: MODIFY_ADDRESS,
  payload: data,
});

export const modifyAddressSuccess = (user) => ({
  type: MODIFY_ADDRESS_SUCCESS,
  payload: user,
});

export const modifyAddressError = (message) => ({
  type: MODIFY_ADDRESS_ERROR,
  payload: message,
});
